import "../../styles/settings/profileComp.css";
import { BsCamera } from "react-icons/bs";
import { MdGppGood } from "react-icons/md";
import { useState, useEffect, useLayoutEffect } from "react";
import { editProfileURL, uploadProductImageUrl, uploadWebstoreImageUrl, verifyEmailURL } from "../../api/endpoints";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../slice/webStoreUserSlice";
import { useNavigate } from "react-router-dom";
import ImageCropper from "../../components/imageCropper/ImageCropper";
import { ButtonLoader, ImageUploadLoader } from "../../components/uxCollections/Loaders";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";
let cloudinaryReduceOptimizeUrl = "https://res.cloudinary.com/demo/image/fetch/w_120,f_auto,q_auto/";

const Profile = () => {
  const [changeAddress, setChangeAddress] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [gender, setGender] = useState(null);
  const [address, setAddress] = useState(null);
  const [state, setState] = useState(null);
  const [wasThereAChange, setWasThereAChange] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [profileImageStage, setProfileImageStage] = useState(null);
  const [profileImageBuffer, setProfileImageBuffer] = useState(null);

  const [openImageCropper, setOpenImageCropper] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.webStoreUser);
  console.log(user);

  useLayoutEffect(() => {
    if (Object.keys(user).length > 0) {
      user.gender && setGender(user.gender);
      user.address && setAddress(user.address.street);
      user.address && setState(user.address.city);
      gender && address && state && setWasThereAChange(false);
      user.userImage && setProfileImage(user.userImage);
    } else {
      console.log("user is empty");
      navigate("/sign-in");
    }
  }, []);

  useEffect(() => {
    address && state && gender && setWasThereAChange(true);
  }, [address, state, gender]);

  useEffect(() => {
    console.log(profileImageBuffer, "profileImageBuffer");
    isLoading && uploadProfileImageFun();
  }, [profileImageBuffer]);

  const uploadProfileImageFun = async () => {
    let imageToUpload = new FormData();
    imageToUpload.append("webstoreUserImage", profileImageBuffer);
    try {
      let response = await fetch(uploadWebstoreImageUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: imageToUpload,
      });
      if (response.ok) {
        let updatedUser = await response.json();
        dispatch(setUser(updatedUser));
        setProfileImage(updatedUser.userImage);
        setIsLoading(false);
      } else {
        uiAlert("error uploading image", "error");
        console.log(response, "error uploading image");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const saveInfo = async () => {
    if (wasThereAChange && address && state && gender) {
      let data = {
        address,
        state,
        gender,
      };
      let token = localStorage.getItem("accessToken");
      let refreshToken = localStorage.getItem("refreshToken");
      try {
        let response = await fetch(editProfileURL, {
          method: "PUT",

          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        });
        if (response.status === 400) {
          /* send refresh token */
          console.log("expired token send refresh token");
        }
        if (response.status === 404 || response.status === 401) {
          console.log("go to login");
          navigate("/sign-in");
        }
        if (response.ok) {
          /* update the store */
          let data = await response.json();
          dispatch(setUser(data));
          console.log(data);
          setWasThereAChange(false);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      console.log("no change");
    }
  };

  const uploadProfileImage = async (e) => {
    setIsLoading(true);
    let imageBuffer = e.target.files[0];

    console.log(imageBuffer.size, "size");
    if (imageBuffer.size > 1000000) {
      uiAlert("image is too large", "warning");
      setIsLoading(false);
      return;
    } else {
      const reader = new FileReader();
      reader.onload = function (evt) {
        setProfileImageStage(evt.target.result);
        setOpenImageCropper(true);
      };
      reader.readAsDataURL(imageBuffer);
    }
  };

  const verifyEmail = async () => {
    console.log(`${verifyEmailURL}/${user._id}`, "verifyEmailURL");

    let payload = {
      email: user.email,
      fullName: user.fullName,
    };
    try {
      let response = await fetch(`${verifyEmailURL}/${user._id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });
      if (response.status === 401) {
        uiAlert("Invalid request, please try again later", "error");
        return;
      }
      if (response.ok) {
        uiAlert("Verification email sent successfully, please check your inbox", "success");
      }
    } catch (error) {
      console.log(error);
      uiAlert("Error verifying email, please try again later", "error");
    }
  };

  return (
    <>
      <div className='profilDivWrapper'>
        <div className='profilDivWrapperdiv'>
          <div className='profilePictureSet'>
            {profileImage ? <img src={profileImage ? profileImage : ""} alt='user-pofile-image' /> : <div> {user.fullName.charAt(0).toUpperCase()} </div>}
            {!isLoading && (
              <>
                <span>
                  <BsCamera />
                </span>
                <input accept='image/*' type={"file"} onChange={(e) => uploadProfileImage(e)} />
              </>
            )}
            {isLoading && (
              <div style={{ borderRadius: "50%" }} id='ImageLoading'>
                {" "}
                <ImageUploadLoader />
              </div>
            )}
          </div>
          <div className='lockedInput'>
            <p>Full name :</p>
            <div>
              {" "}
              <p>{user.fullName}</p>
            </div>
          </div>
          <div className='lockedInput'>
            <p>Email :</p>
            <div>
              {" "}
              <p>{user.email}</p>{" "}
              {user.isEmailVerified ? (
                <MdGppGood color='green' />
              ) : (
                <button onClick={verifyEmail} className='verifyEmailButton'>
                  Verify
                </button>
              )}
            </div>
          </div>
          <div className='lockedInput'>
            <p>Phone Number :</p>
            <div>
              {" "}
              <p>{user.phoneNumber}</p> <MdGppGood color='green' />
            </div>
          </div>
          <div className='lockedInput'>
            <p>Gender :</p>
            {!gender ? (
              <select value={gender} onChange={(e) => setGender(e.target.value)} className='selectGender' placeholder='Select' disabled={gender ? true : false}>
                <option value='' disabled selected hidden>
                  Select gender
                </option>
                <option>Male</option>
                <option>Female</option>
              </select>
            ) : (
              <p>{gender}</p>
            )}
          </div>
          <div className='lockedInput'>
            <p>Address :</p>
            <div>
              {" "}
              {!changeAddress ? (
                <p>{address}</p>
              ) : (
                <input autoFocus={true} onChange={(e) => setAddress(e.target.value)} placeholder='Enter your home address' />
              )}
              {/*   {changeAddress ? (
                <p
                  onClick={() => setChangeAddress(false)}
                  className="chnaheAddresbtn"
                >
                  Save
                </p>
              ) : (
                <p
                  onClick={() => setChangeAddress(true)}
                  className="chnaheAddresbtn"
                >
                  Change Address
                </p>
              )} */}
              {changeAddress && (
                <p onClick={() => setChangeAddress(false)} className='chnaheAddresbtn'>
                  Save
                </p>
              )}
              {!changeAddress && !address && (
                <p onClick={() => setChangeAddress(true)} className='chnaheAddresbtn'>
                  Add Address
                </p>
              )}
            </div>
          </div>
          <div className='lockedInput'>
            <p>State :</p>
            <div>
              {" "}
              {!state ? (
                <select value={state} onChange={(e) => setState(e.target.value)} disabled={state ? true : false} className='selectState' placeholder='Select'>
                  <option value='' disabled selected hidden>
                    Select your state of origin
                  </option>
                  {nigeriaStates.map((state, i) => (
                    <option key={i} value={state.value}>
                      {state.name}
                    </option>
                  ))}
                </select>
              ) : (
                <p>{state}</p>
              )}
            </div>
          </div>
          {wasThereAChange && (
            <p onClick={() => saveInfo()} className='saveProfileChange'>
              save
            </p>
          )}
        </div>
        <div className='pickedCountry'>
          <img
            src={
              user.userCountryFlag
                ? user.userCountryFlag
                : "https://thumbs.dreamstime.com/b/icon-flag-nigeria-round-glossy-vector-illustration-eps-button-badge-193853437.jpg"
            }
          />
          {user.userCountry}
        </div>
      </div>
      {openImageCropper && (
        <ImageCropper
          readImageUrl={profileImageStage}
          setCroppedImageUrl={setProfileImageStage}
          setCroppedImageBolb={setProfileImageBuffer}
          closeModal={setOpenImageCropper}
        />
      )}
    </>
  );
};

export default Profile;

const nigeriaStates = [
  { name: "Abia", value: "Abia" },
  { name: "Adamawa", value: "Adamawa" },
  { name: "Akwa Ibom", value: "Akwa Ibom" },
  { name: "Anambra", value: "Anambra" },
  { name: "Bauchi", value: "Bauchi" },
  { name: "Bayelsa", value: "Bayelsa" },
  { name: "Benue", value: "Benue" },
  { name: "Borno", value: "Borno" },
  { name: "Cross River", value: "Cross River" },
  { name: "Delta", value: "Delta" },
  { name: "Ebonyi", value: "Ebonyi" },
  { name: "Edo", value: "Edo" },
  { name: "Ekiti", value: "Ekiti" },
  { name: "Enugu", value: "Enugu" },
  { name: "Gombe", value: "Gombe" },
  { name: "Imo", value: "Imo" },
  { name: "Jigawa", value: "Jigawa" },
  { name: "Kaduna", value: "Kaduna" },
  { name: "Kano", value: "Kano" },
  { name: "Katsina", value: "Katsina" },
  { name: "Kebbi", value: "Kebbi" },
  { name: "Kogi", value: "Kogi" },
  { name: "Kwara", value: "Kwara" },
  { name: "Lagos", value: "Lagos" },
  { name: "Nasarawa", value: "Nasarawa" },
  { name: "Niger", value: "Niger" },
  { name: "Ogun", value: "Ogun" },
  { name: "Ondo", value: "Ondo" },
  { name: "Osun", value: "Osun" },
  { name: "Oyo", value: "Oyo" },
  { name: "Plateau", value: "Plateau" },
  { name: "Rivers", value: "Rivers" },
  { name: "Sokoto", value: "Sokoto" },
  { name: "Taraba", value: "Taraba" },
  { name: "Yobe", value: "Yobe" },
  { name: "Zamfara", value: "Zamfara" },
  { name: "Federal Capital Territory", value: "FCT" },
];

export const ProfilePage = () => {
  const [changeAddress, setChangeAddress] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState("");
  const [wasThereAChange, setWasThereAChange] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // for images
  const [loading, setLoading] = useState(false); // for profile info
  const [profileImageStage, setProfileImageStage] = useState(null);
  const [profileImageBuffer, setProfileImageBuffer] = useState(null);
  const [isProfileComplete, setIsProfileComplete] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [sendingVerificationEmail, setSendingVerificationEmailading] = useState(false);

  const [openImageCropper, setOpenImageCropper] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.webStoreUser);

  useLayoutEffect(() => {
    if (Object.keys(user).length > 0) {
      user.gender && setGender(user.gender);
      user.address?.street && setAddress(user.address.street);
      user.address?.city && setState(user.address.city);
      user.gender && user.address?.street && user.address?.city && setWasThereAChange(false);
      /* console.log(user.address, user.address.street, user.gender, user.address.city); */

      user.gender && user.address?.street && user.address?.city && setIsProfileComplete(true);
      user.userImage && setProfileImage(user.userImage);
    } else {
      console.log("user is empty");
      navigate("/sign-in");
    }
  }, [user]);

  useEffect(() => {
    isLoading && uploadProfileImageFun();
  }, [profileImageBuffer]);
  /* useEffect(() => {
    setIsLoading(false);
  }, [openImageCropper]); */

  useEffect(() => {
    if ((gender, address, state)) {
      setWasThereAChange(true);
    } else {
      setWasThereAChange(false);
      let missingFields = [];
      !address && missingFields.push("Enter your address");
      !state && missingFields.push("Select state");
      !gender && missingFields.push("Select gender");
      setMissingFields(missingFields);
      console.log(missingFields, "missingFields");
    }
  }, [gender, address, state]);

  const uploadProfileImageFun = async () => {
    let imageToUpload = new FormData();
    imageToUpload.append("webstoreUserImage", profileImageBuffer);
    try {
      let response = await fetch(uploadWebstoreImageUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: imageToUpload,
      });
      if (response.ok) {
        let updatedUser = await response.json();
        dispatch(setUser(updatedUser));
        setProfileImage(updatedUser.userImage);
        setIsLoading(false);
      } else {
        uiAlert("error uploading image", "error");
        console.log(response, "error uploading image");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const uploadProfileImage = async (e) => {
    setIsLoading(true);
    let imageBuffer = e.target.files[0];

    console.log(imageBuffer.size, "size");
    if (imageBuffer.size > 1000000) {
      uiAlert("image is too large", "warning");
      setIsLoading(false);
      return;
    } else {
      const reader = new FileReader();
      reader.onload = function (evt) {
        setProfileImageStage(evt.target.result);
        setOpenImageCropper(true);
      };
      reader.readAsDataURL(imageBuffer);
    }
  };
  const verifyEmail = async (e) => {
    e.preventDefault();
    setSendingVerificationEmailading(true);
    let payload = {
      email: user.email,
      fullName: user.fullName,
    };
    try {
      let response = await fetch(`${verifyEmailURL}/${user._id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });
      if (response.status === 401) {
        uiAlert("Invalid request, please try again later", "error");
        return;
      }
      if (response.status === 404) {
        uiAlert("Please login again, your session has expired", "error");
        navigate("/sign-in");
        return;
      }
      if (response.ok) {
        uiAlert("Verification email sent successfully, please check your inbox", "success");
      }
    } catch (error) {
      console.log(error);
      uiAlert("Error verifying email, please try again later", "error");
    } finally {
      setSendingVerificationEmailading(false);
    }
  };

  const saveInfo = async () => {
    if (wasThereAChange && address && state && gender) {
      let data = {
        address,
        state,
        gender,
      };
      let token = localStorage.getItem("accessToken");
      let refreshToken = localStorage.getItem("refreshToken");
      try {
        setLoading(true);
        let response = await fetch(editProfileURL, {
          method: "PUT",

          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        });
        if (response.status === 400) {
          /* send refresh token */
          console.log("expired token send refresh token");
        }
        if (response.status === 404 || response.status === 401) {
          console.log("go to login");
          navigate("/sign-in");
        }
        if (response.ok) {
          /* update the store */
          let data = await response.json();
          dispatch(setUser(data));
          console.log(data);
          setWasThereAChange(false);
        }
      } catch (error) {
        uiAlert("Error saving profile information, please try again later", "error");
        console.log(error);
      } finally {
        setLoading(false);
      }
    } else {
      uiAlert(missingFields.join(", "));
      console.log("no change");
    }
  };

  /* new */

  const [formData, setFormData] = useState({
    fullName: "Eyo Mad",
    email: "eyomad9@gmail.com",
    phoneNumber: "+4591447264",
    gender: "",
    address: "",
    state: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <div className='profile-page-container'>
        {/*   <div className='profile-page-sidebar'>
          <div className='profile-sidebar-nav'>
            <div className='profile-nav-item profile-nav-active'>
              <div className='profile-nav-icon profile-user-icon'></div>
            </div>
            <div className='profile-nav-item'>
              <div className='profile-nav-icon profile-card-icon'></div>
            </div>
            <div className='profile-nav-item'>
              <div className='profile-nav-icon profile-folder-icon'></div>
            </div>
            <div className='profile-nav-item'>
              <div className='profile-nav-icon profile-lock-icon'></div>
            </div>
            <div className='profile-nav-item'>
              <div className='profile-nav-icon profile-history-icon'></div>
            </div>
            <div className='profile-nav-item'>
              <div className='profile-nav-icon profile-help-icon'></div>
            </div>
          </div>
          <div className='profile-sidebar-footer'>
            <button className='profile-delete-btn'>Delete Account</button>
          </div>
        </div> */}
        {/* <div className='pickedCountry'>
          <img
            src={
              user.userCountryFlag
                ? user.userCountryFlag
                : "https://thumbs.dreamstime.com/b/icon-flag-nigeria-round-glossy-vector-illustration-eps-button-badge-193853437.jpg"
            }
          />
          {user.userCountry}
        </div> */}
        <div className='profile-page-main'>
          <div className='profile-page-header'>
            <div className='profile-country-flag'>
              <img
                className='countryFlagImage'
                src={
                  user.userCountryFlag
                    ? user.userCountryFlag
                    : "https://thumbs.dreamstime.com/b/icon-flag-nigeria-round-glossy-vector-illustration-eps-button-badge-193853437.jpg"
                }
              />
              <span className='profile-country-name'> {user.userCountry}</span>
            </div>
          </div>

          <div className='profile-form-container'>
            {/* <div className='profile-avatar-section'>
              <div className='profile-avatar-circle'>
                <span className='profile-avatar-letter'>E</span>
                <div className='profile-camera-icon'></div>
              </div>
            </div> */}
            <div className='profile-avatar-section'>
              <div className='profilePictureSet'>
                {profileImage ? <img src={profileImage ? profileImage : ""} alt='user-pofile-image' /> : <div> {user.fullName.charAt(0).toUpperCase()} </div>}
                {!isLoading && (
                  <>
                    <span>
                      <BsCamera />
                    </span>
                    <input accept='image/*' type={"file"} onChange={(e) => uploadProfileImage(e)} />
                  </>
                )}
                {isLoading && (
                  <div style={{ borderRadius: "50%" }} id='ImageLoading'>
                    {" "}
                    <ImageUploadLoader />
                  </div>
                )}
              </div>
            </div>

            <form className='profile-form'>
              <div className='profile-form-group'>
                <label className='profile-form-label'>Full name :</label>
                <input disabled type='text' name='fullName' value={user.fullName} onChange={handleInputChange} className='profile-form-input' />
              </div>

              <div className='profile-form-group'>
                <label className='profile-form-label'>Email :</label>
                <div className='profile-input-container'>
                  <input
                    disabled
                    type='email'
                    name='email'
                    value={user.email}
                    onChange={handleInputChange}
                    className='profile-form-input profile-verified-input'
                  />
                  {/*  {user.isEmailVerified ? (
                  <MdGppGood color='green' />
                ) : (
                  <button onClick={verifyEmail} className='verifyEmailButton'>
                    Verify
                  </button>
                )} */}
                  {user.isEmailVerified ? (
                    <div className='profile-verified-badge'></div>
                  ) : sendingVerificationEmail ? (
                    <button className='verifyEmailButton'>
                      <ButtonLoader />
                    </button>
                  ) : (
                    <button onClick={(e) => verifyEmail(e)} className='verifyEmailButton'>
                      Verify
                    </button>
                  )}
                </div>
              </div>

              <div className='profile-form-group'>
                <label className='profile-form-label'>Phone Number :</label>
                <div className='profile-input-container'>
                  <input
                    disabled
                    type='tel'
                    name='phoneNumber'
                    value={user.phoneNumber}
                    onChange={handleInputChange}
                    className='profile-form-input profile-verified-input'
                  />
                  <div className='profile-verified-badge'></div>
                </div>
              </div>

              <div className='profile-form-group'>
                <label className='profile-form-label'>Gender :</label>
                <select
                  disabled={isProfileComplete ? true : false}
                  name='gender'
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  className='profile-form-select'
                >
                  <option value=''>Select gender</option>
                  <option value='male'>Male</option>
                  <option value='female'>Female</option>
                  <option value='other'>Other</option>
                  <option value='prefer-not-to-say'>Prefer not to say</option>
                </select>
              </div>

              <div className='profile-form-group'>
                <label className='profile-form-label'>Address :</label>
                {/*  <button
                  type='button'
                  className='profile-add-address-btn'
                  onClick={() => {
                    // Handle add address functionality
                  }}
                >
                  Add Address
                </button> */}
                <input
                  type='text'
                  name='phoneNumber'
                  disabled={isProfileComplete ? true : false}
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder='Enter your home address'
                  className='profile-form-input profile-verified-input'
                />
              </div>

              <div className='profile-form-group'>
                <label className='profile-form-label'>State :</label>
                <select
                  disabled={isProfileComplete ? true : false}
                  name='state'
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  className='profile-form-select'
                >
                  <option value=''>Select your state of origin</option>
                  {/* <option value='capital'>Capital Region</option>
                  <option value='central'>Central Denmark</option>
                  <option value='north'>North Denmark</option>
                  <option value='zealand'>Zealand</option>
                  <option value='southern'>Southern Denmark</option> */}
                  {nigeriaStates.map((state, i) => (
                    <option key={i} value={state.value}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
            </form>

            {!isProfileComplete &&
              (loading ? (
                <button className='saveXPro465'>
                  <ButtonLoader />
                </button>
              ) : (
                <button onClick={() => saveInfo()} className='saveXPro465'>
                  Save Changes
                </button>
              ))}
          </div>
        </div>
      </div>
      {openImageCropper && (
        <ImageCropper
          readImageUrl={profileImageStage}
          setCroppedImageUrl={setProfileImageStage}
          setCroppedImageBolb={setProfileImageBuffer}
          closeModal={setOpenImageCropper}
        />
      )}
    </>
  );
};
